import { api } from '@/lib/api';
import { type WidgetRenderRequest, WidgetRenderRequestSchema } from '@innermate/shared';

/**
 * iframe 으로부터 widget-render-request message 를 받으면 endpoint 호출 후 응답을 다시
 * iframe.contentWindow 로 postMessage. useArtifactBridge / useDashboardBridge 양쪽에서 공유.
 */
export function handleWidgetRenderRequest(
  iframe: HTMLIFrameElement,
  data: { reqId: unknown; payload: unknown },
): void {
  const reqId = typeof data.reqId === 'number' ? data.reqId : 0;
  const parsed = WidgetRenderRequestSchema.safeParse(data.payload);
  if (!parsed.success) {
    iframe.contentWindow?.postMessage(
      {
        kind: 'dashboard.widget-render-response',
        reqId,
        error: 'widget-render payload 검증 실패',
      },
      '*',
    );
    return;
  }
  const payload: WidgetRenderRequest = parsed.data;
  api
    .dashboardWidgetRender(payload)
    .then((res) => {
      iframe.contentWindow?.postMessage(
        {
          kind: 'dashboard.widget-render-response',
          reqId,
          html: res.html,
          script: res.script,
        },
        '*',
      );
    })
    .catch((err) => {
      iframe.contentWindow?.postMessage(
        {
          kind: 'dashboard.widget-render-response',
          reqId,
          error: err instanceof Error ? err.message : 'widget-render 호출 실패',
        },
        '*',
      );
    });
}
